module.exports = __webpack_public_path__ + "static/media/signal.43badacb.svg";